
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[club]",
      function () {
        return require("private-next-pages/[club].js");
      }
    ]);
  